import { router } from "umi";
import { getRouteByPath } from "@/utils/route";
import { stopTrackingLoggedInUserForDatadog } from "@/utils/setupDatadog";
import { revokeToken, AccountLogin } from "@/services/login";
import { setSessionStorage, removeSessionStorage, getSessionStorage, getLocalStorage } from "./storage";

const redirectFn = username => {
  if (!username) {
    router.replace("");
    return;
  }

  // look for redirect url in local storage and remove it after use
  const redirectUrlForUserKey = `redirectUrl-${username}`;
  const redirectUrlForUser = getSessionStorage(redirectUrlForUserKey);
  const redirectUrl = `/${redirectUrlForUser ? `?redirectTo=${redirectUrlForUser}` : ""}`;

  removeSessionStorage(redirectUrlForUserKey);

  router.replace(redirectUrl);
};

export async function login(data) {
  const response = await AccountLogin(data);

  // if response is ok, redirect the user
  if (response.ok) {
    redirectFn(data.username);
    return { ok: true };
  }

  return { error: response.error };
}

export async function logout(username) {
  try {
    const { pathname, search } = window.location;
    let dataAuth = getLocalStorage("dataAuth");
    let token = dataAuth?.refresh_token;

    const route = getRouteByPath(pathname);

    if (username && !route.cannotRedirectTo) {
      // save current page for this user for this session
      setSessionStorage(`redirectUrl-${username}`, pathname + search);
    }

    if (token) {
      await revokeToken({ token });
    }

    stopTrackingLoggedInUserForDatadog();

    return { ok: true };
  } catch (error) {
    console.error(error);
    return { error: error };
  }
}
